/**
 * Getters for events
 */
export const getters = {
  getValidated(state) {
    return state.validated;
  }
};
